import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { Field, FieldProps } from 'formik'
import { Box, Text, Input, Flex, FormField, H2 } from '../../../components'
import { validationMessages } from '../../../lib/messages'
import { isEmail } from '../../../lib/util'
import { LargeMail as MailIcon } from '@urbaninfrastructure/react-icons'
import { labelMessages } from '../messages'
import { Values } from '../types'

function validateEmail(value) {
  let error
  if (!value) {
    error = 'EMAIL_REQUIRED'
  }
  if (!isEmail(value)) {
    error = 'EMAIL_INVALID'
  }
  return error
}

const EmailStep = () => {
  const intl = useIntl()
  const fieldName = 'receiptEmail'
  return (
    <Flex
      flex={1}
      flexWrap="wrap"
      mb="sm"
      textAlign="center"
      justifyContent="center"
    >
      <Box mb="sm">
        <MailIcon size="80px" color="primary" />

        <H2 mb={0} typoStyle="md" mt="sm">
          <label htmlFor={fieldName}>
            <FormattedMessage {...labelMessages.receiptEmail} />
          </label>
        </H2>
      </Box>

      <Box width="22rem">
        <Field name={fieldName} validate={validateEmail}>
          {({ field, form }: FieldProps<Values['receiptEmail'], Values>) => {
            const error = form.touched[field.name] && form.errors[field.name]
            const errorMessage = error && validationMessages[error] && (
              <FormattedMessage {...validationMessages[error]} />
            )
            return (
              <FormField
                wrapperProps={{ mb: 'sm' }}
                errorMessage={errorMessage}
              >
                <Input
                  id={field.name}
                  {...field}
                  type="email"
                  aria-label={intl.formatMessage(labelMessages.receiptEmail)}
                  alternative
                  autoFocus
                />
              </FormField>
            )
          }}
        </Field>
      </Box>

      <Box maxWidth="22rem">
        <Text typoStyle="xxs" mute>
          <FormattedMessage
            id="modules.Registration.EmailStep.description"
            defaultMessage="We will send all payment receipts to this email address. If you like, you can use a different email address than the one you use to log in."
          />
        </Text>
      </Box>
    </Flex>
  )
}

export default EmailStep
